/**
 * Preferences service singleton for the console.
 *
 * Descriptors must already be registered (via `bootstrapDataAccess` →
 * `registerDescriptors`) before `hydrate`. Adapters and non-React stores
 * import this instance directly — the React `PreferencesProvider` only owns
 * the hydrate / reset lifecycle.
 */

import { createWebLocalStorageAdapter } from '@rammetec/data-access'
import { createPreferencesService } from '@rammetec/data-access/preferences'

export const preferencesService = createPreferencesService({
  storage: createWebLocalStorageAdapter(),
})
